module.exports = __webpack_public_path__ + "static/media/Hitmonlee_gaussian2.69241736.png";